import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { ErrorResponse } from "../../../requests/@types";
import api from "../../../services/api";
import { ReportCloudSandbox } from "../@types";
import { isSha1Hash } from "../utils";

interface RlCloudSandboxData {
  report: ReportCloudSandbox | undefined;
  isError: boolean;
  isSuccess: boolean;
  isFetching: boolean;
  refetch: () => Promise<unknown>;
}

const useRlCloudSandboxReport = (
  sha1: string,
  options?: Partial<
    UseQueryOptions<
      AxiosResponse<ReportCloudSandbox>,
      ErrorResponse<string>,
      ReportCloudSandbox | undefined
    >
  >
): RlCloudSandboxData => {
  const { data, isError, isSuccess, isFetching, refetch } = useQuery({
    queryKey: ["rlcloudsandbox_merged_report", sha1],
    queryFn: () => api.rlSandboxMergedReport(sha1),
    select: resp => resp.data,
    enabled: !!sha1 && isSha1Hash(sha1),
    throwOnError: error => error?.status >= 500,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
    ...options
  });

  return {
    report: data,
    isError,
    isSuccess,
    isFetching,
    refetch
  };
};
export default useRlCloudSandboxReport;
